<div>
    <div class="agpr-bulk-action-form-tag-radio">
        <agpr-radio
            id="bulkActionForm.taggingMethodSelection.chooseTags"
            [label]="'Monitoring.bulk.action.addTag.radioLabel'"
            [value]="taggingMethodSelectionEnum.chooseTags"
            [(ngModel)]="selectedTaggingMethod"
            (ngModelChange)="changeTaggingMethod($event)"
        >
        </agpr-radio>
    </div>
    <div
        *ngIf="selectedTaggingMethod === taggingMethodSelectionEnum.chooseTags"
        class="agpr-bulk-action-form-tag-pickerContainer"
    >
        <div class="agpr-labelSpacing">
            <label id="bulkActionFormTag_autocompleteLabel">
                {{ 'Tags.tags' | localize }}
                <span class="agpr-labelSpacing-required" aria-hidden="true"> * </span>
            </label>
            <span
                role="img"
                class="agpr-infoIconStyle fa-regular fa-circle-info"
                agprTooltip="Tags.info"
            ></span>
        </div>
        <agpr-autocomplete
            [id]="'bulkAction.removeTags.tagSelector'"
            labelField="name"
            placeholder="Tags.inputPlaceholder"
            [disabled]="selectedTaggingMethod !== taggingMethodSelectionEnum.chooseTags"
            [dropdown]="true"
            ariaLabelledBy="bulkActionFormTag_autocompleteLabel"
            [(ngModel)]="selectedTag"
            (itemSelected)="emitModelChange()"
            [customOptions]="customOptions"
            [suggestions]="tagList$"
            [clearOnBlur]="false"
            [multiSelection]="false"
            [required]="true"
        ></agpr-autocomplete>
    </div>
    <div class="agpr-bulk-action-form-tag-radio">
        <agpr-radio
            id="bulkActionForm.taggingMethodSelection.basedOnTaggingTopics"
            class="agpr-bulk-action-form-tag-radio"
            [label]="'Monitoring.bulk.action.addTagBasedOnTaggingTopics.radioLabel'"
            [value]="taggingMethodSelectionEnum.basedOnTaggingTopics"
            [(ngModel)]="selectedTaggingMethod"
            (ngModelChange)="changeTaggingMethod($event)"
            tooltip="Monitoring.bulk.action.addTagBasedOnTaggingTopics.radioTooltip"
        >
        </agpr-radio>
        @if (selectedTaggingMethod === taggingMethodSelectionEnum.basedOnTaggingTopics) {
            <div
                class="agpr-bulk-action-form-tag-taggingTopics"
                [ngClass]="{'agpr-bulk-action-form-tag-taggingTopics--withChips': taggingTopicChips && taggingTopicChips.length}"
            >
                <agpr-autocomplete
                    #taggingTopicsAutocomplete
                    [id]="'bulkAction_taggingMethodSelection_basedOnTaggingTopics_topicAutocomplete'"
                    labelField="name"
                    label="Monitoring.bulk.action.addTagBasedOnTaggingTopics.autoComplete"
                    placeholder="Monitoring.bulk.action.addTagBasedOnTaggingTopics.autoComplete.placeholder"
                    ariaLabelledBy="bulkActionForm.taggingMethodSelection.basedOnTaggingTopics"
                    [(ngModel)]="selectedTaggingTopics"
                    (itemSelected)="selectTaggingTopic($event)"
                    [suggestions]="taggingTopicList$"
                    [clearOnBlur]="true"
                    [multiSelection]="true"
                    [dropdown]="true"
                ></agpr-autocomplete>
                @if (taggingTopicChips && taggingTopicChips.length) {
                    <div class="agpr-bulk-action-form-tag-taggingTopics-chips">
                        <agpr-chip-container
                            [id]="'bulkAction_taggingMethodSelection_basedOnTaggingTopics_chips'"
                            [chips]="taggingTopicChips"
                            (removeChip)="removeTaggingTopicChip($event)"
                        ></agpr-chip-container>
                    </div>
                }
            </div>
        }
    </div>
</div>
